export const userAction = {
  blockUser: "Utilizatorul a fost blocat cu succes!",
  unblockUser: "Utilizatorul a fost deblocat cu succes!",
  resendInvitation: "Invitația a fost retrimisă cu succes!",
};
